/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IStaminaCostOf,
  IStaminaCostOfInterface,
} from "../IStaminaCostOf";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "queueId",
        type: "uint256",
      },
    ],
    name: "staminaCostOf",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IStaminaCostOf__factory {
  static readonly abi = _abi;
  static createInterface(): IStaminaCostOfInterface {
    return new utils.Interface(_abi) as IStaminaCostOfInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IStaminaCostOf {
    return new Contract(address, _abi, signerOrProvider) as IStaminaCostOf;
  }
}
